// extracted by mini-css-extract-plugin
export var divider = "_fy-7";
export var itemsToggle = "_fy-8";
export var mergeModal = "_fy-1";
export var optionCard = "_fy-4";
export var radioGroup = "_fy-6";
export var radioOption = "_fy-0";
export var selected = "_fy-5";
export var shipmentOptions = "_fy-2";
export var tableOptions = "_fy-3";